// Общие детали дашбордов ТМ/РМ: пилюли метрик, плитки, CSS, выбор дат периода.
import { useRef, useState } from 'react';
import { aggregateHyper, aggregateWeeks } from '../lib/data';

export function datesFor(periodSel, weeks, weekNums) {
  if (periodSel === 'month') return weekNums.flatMap(w => (weeks[w]?.days || []).map(d => d.date));
  return (weeks[periodSel]?.days || []).map(d => d.date);
}

// Выбор недель для периода: 'month' → все недели, иначе одна выбранная.
export function weeksFor(periodSel, weekNums) {
  return periodSel === 'month' ? weekNums : [periodSel];
}

export function pqPill(p, z) {
  const v = z ? Math.round(p / z * 100) : 0;
  const c = v >= 100 ? 'ok' : v >= 97 ? 'warn' : 'bad';
  return <span className={'dpill ' + c}><b>{p}/{z}</b> · {v}%</span>;
}
export function pfPill(p, f) {
  const v = f ? Math.round(p / f * 100) : 0;
  const d = Math.abs(100 - v);
  const c = d <= 5 ? 'ok' : d <= 12 ? 'warn' : 'bad';
  const dd = p - f;
  return <span className={'dpill ' + c}><b>{p}/{f}</b> · {v}% ({dd > 0 ? '+' : ''}{dd})</span>;
}
export function slPill(f, z) {
  const v = z ? Math.round(f / z * 100) : 0;
  const c = v >= 95 ? 'ok' : v >= 90 ? 'warn' : 'bad';
  return <span className={'dpill ' + c}><b>{f}/{z}</b> · {v}%</span>;
}
export function cntPill(v, cls) { return <span className={'dpill ' + (v ? cls : 'zero')}>{v}</span>; }

export function metricTile(lab, val) {
  return <div className="dm"><span className="lab">{lab}</span><span className="val">{val}</span></div>;
}

export const DASH_CSS = `
.dpill{font-size:11px;font-weight:600;border-radius:20px;padding:2px 8px;white-space:nowrap;font-variant-numeric:tabular-nums}
.dpill b{font-weight:700}
.dpill.ok{background:#E4F2EA;color:#2e7d52}.dpill.warn{background:#FAF0DA;color:#a8720c}.dpill.bad{background:#FBE9E7;color:#c0392b}
.dpill.cov{background:#e7f0f9;color:#185fa5}.dpill.vac{background:#efeafc;color:#5a3fb0}.dpill.zero{background:#F0F0F0;color:#888}
.dm{display:flex;flex-direction:column;gap:1px;align-items:center;background:#f7f8f6;border-radius:8px;padding:4px 9px;min-width:46px}
.dm .lab{font-size:9px;color:#888;text-transform:uppercase}
.dm .val{font-size:14px;font-weight:700;font-variant-numeric:tabular-nums}
.dgrp{display:flex;gap:6px;flex-wrap:wrap;align-items:stretch}
.dseg{display:inline-flex;border:1px solid var(--border);border-radius:8px;overflow:hidden}
.dseg button{border:0;background:white;color:var(--text-muted);font:inherit;font-size:12px;padding:6px 12px;cursor:pointer}
.dseg button.on{background:var(--accent);color:#fff;font-weight:600}
.dseg.disc button.on{background:#6a4bbc}
.dseg.hyp button.on{background:#0f766e}

/* График динамики */
.dyn-wrap{width:100%}
.dyn-legend{display:flex;gap:14px;flex-wrap:wrap;margin-bottom:6px}
.dyn-lg{display:inline-flex;align-items:center;gap:6px;font-size:11px;color:var(--text-muted);font-weight:600}
.dyn-sw{width:16px;height:3px;border-radius:2px;display:inline-block;flex:none}
.dyn-tip{position:absolute;top:6px;transform:translateX(-50%);background:var(--text);color:#fff;border-radius:8px;padding:6px 9px;font-size:11px;pointer-events:none;box-shadow:0 4px 12px rgba(0,0,0,.18);white-space:nowrap;z-index:5}
.dyn-tip-h{font-weight:700;margin-bottom:3px;font-size:11px}
.dyn-tip-r{display:flex;align-items:center;gap:6px;line-height:1.7}
.dyn-tip-r .dyn-sw{border-top-width:3px;width:12px}
.dyn-tip-r b{margin-left:auto;padding-left:10px;font-variant-numeric:tabular-nums}

/* Триггеры */
.trigwrap{background:var(--surface);border:1px solid var(--border);border-radius:10px;box-shadow:var(--shadow);padding:12px 14px;margin-bottom:12px}
.trig-h{font-size:12px;font-weight:700;color:var(--text-muted);margin-bottom:8px}
.trig-empty{font-size:13px;color:#2e7d52;background:#E4F2EA;border-radius:8px;padding:9px 12px;font-weight:600}
.trig{display:flex;align-items:center;gap:11px;border-radius:9px;padding:10px 12px;border-left:4px solid var(--red);background:#FBECEB;margin-top:6px}
.trig.warn{border-left-color:#a8720c;background:#FAF3E2}.trig.info{border-left-color:#185fa5;background:#E9F1FA}
.trig-ic{width:26px;height:26px;border-radius:8px;background:#FBE0DD;color:#c0392b;display:grid;place-items:center;font-weight:800;flex:none}
.trig.warn .trig-ic{background:#F6E7C8;color:#a8720c}.trig.info .trig-ic{background:#D6E6F6;color:#185fa5}
.trig-txt{display:flex;flex-direction:column;line-height:1.3}
.trig-txt{flex:1;min-width:0}
.trig-go{margin-left:auto;flex:none;border:1px solid #BBD6EE;background:#EBF4FF;color:#1F5F9C;border-radius:6px;padding:5px 12px;font-size:12px;font-weight:600;cursor:pointer}
.trig-txt b{font-size:13.5px}.trig-txt span{font-size:12px;color:var(--text-muted)}

/* Табы-переключатели */
.stabs{display:flex;align-items:center;gap:6px;flex-wrap:wrap;margin-bottom:8px}
.stabs-l{font-size:11px;font-weight:700;color:var(--text-light);text-transform:uppercase;margin-right:2px}
.stab{border:1px solid var(--border);background:var(--surface);color:var(--text-muted);border-radius:20px;padding:5px 12px;font-size:12px;font-weight:600;cursor:pointer;font-family:inherit}
.stab.on{background:var(--accent);color:#fff;border-color:var(--accent)}

/* Полоса недель */
.wstrip{display:grid;grid-template-columns:repeat(auto-fit,minmax(120px,1fr));gap:8px}
.wcard{background:var(--surface2);border:1px solid var(--border);border-radius:10px;padding:10px 12px}
.wtop{display:flex;align-items:center;justify-content:space-between;margin-bottom:4px}
.wtop .wk{font-size:12px;font-weight:700;color:var(--text-muted);letter-spacing:.3px}
.wsl{font-size:10px;font-weight:700;border-radius:20px;padding:1px 7px}
.wsl.ok{background:#E4F2EA;color:#2e7d52}.wsl.warn{background:#FAF0DA;color:#a8720c}.wsl.bad{background:#FBE9E7;color:#c0392b}
.wbig{font-size:30px;font-weight:800;line-height:1;font-variant-numeric:tabular-nums;display:flex;align-items:baseline;gap:6px}
.wbig-u{font-size:10px;font-weight:600;color:var(--text-light);text-transform:uppercase}
.wsub{font-size:10px;color:var(--text-light);margin-top:2px}
.wfact{margin-top:7px;display:flex;align-items:baseline;gap:5px;font-size:11px;color:var(--text-muted);border-top:1px solid var(--border);padding-top:7px}
.wfact b{font-size:17px;font-weight:800;color:var(--text);font-variant-numeric:tabular-nums;line-height:1}
.wfact-vs{color:var(--text-light);font-variant-numeric:tabular-nums}
.wrow2{display:flex;gap:6px;margin-top:8px}
.wmini{flex:1;background:var(--surface);border:1px solid var(--border);border-radius:7px;padding:4px 6px;display:flex;flex-direction:column;gap:1px}
.wmini span{font-size:9px;color:var(--text-light);text-transform:uppercase}
.wmini b{font-size:13px;font-variant-numeric:tabular-nums}
.wdisc{display:flex;flex-direction:column;gap:5px;margin-top:2px}
.wd{display:flex;align-items:center;justify-content:space-between;border-radius:7px;padding:5px 9px}
.wd span{font-size:11px;font-weight:600}
.wd b{font-size:18px;font-variant-numeric:tabular-nums;line-height:1}
.wd b small{font-size:10px;font-weight:600;opacity:.7;margin-left:3px}
.wd.cov{background:#e9f1fa;color:#185fa5}.wd.bad{background:#fbeceb;color:#c0392b}
.wd.warn{background:#faf3e2;color:#a8720c}.wd.vac{background:#efeafc;color:#5a3fb0}
`;

// Плитки KPI и Дисциплины по агрегату a
export function KpiTiles({ a }) {
  return (<>
    <div className="dgrp">{metricTile('Актив. маршрутов', `${a.activeR} / ${a.routes}`)}{metricTile('Визитов', a.fact)}</div>
    <div className="dgrp" style={{ borderLeft: '1px solid var(--border)', marginLeft: 4, paddingLeft: 8 }}>
      <div className="dm" style={{ minWidth: 'auto' }}><span className="lab">Прогноз/Заказ</span><span className="val">{pqPill(a.plan, a.order)}</span></div>
      <div className="dm" style={{ minWidth: 'auto' }}><span className="lab">Прогноз/Факт</span><span className="val">{pfPill(a.plan, a.fact)}</span></div>
      <div className="dm" style={{ minWidth: 'auto' }}><span className="lab">SL Факт/Заказ</span><span className="val">{slPill(a.fact, a.order)}</span></div>
    </div>
  </>);
}
export function HyperTiles({ a }) {
  return (<>
    <div className="dgrp">{metricTile('Точек', a.points)}{metricTile('Заказ', a.order)}{metricTile('План', a.plan)}{metricTile('Факт', a.fact)}</div>
    <div className="dgrp" style={{ borderLeft: '1px solid var(--border)', marginLeft: 4, paddingLeft: 8 }}>
      <div className="dm" style={{ minWidth: 'auto' }}><span className="lab">SL Факт/Заказ</span><span className="val">{slPill(a.fact, a.order)}</span></div>
      <div className="dm" style={{ minWidth: 'auto' }}><span className="lab">Ниже нормы</span><span className="val">{cntPill(a.below, 'bad')} <span style={{ fontSize: 10, color: '#888' }}>из {a.withOrder}</span></span></div>
    </div>
  </>);
}
export function DiscTiles({ a }) {
  return (<div className="dgrp">
    <div className="dm" style={{ minWidth: 'auto' }}><span className="lab">Перекрытий</span><span className="val">{cntPill(a.overlaps, 'cov')}</span></div>
    <div className="dm" style={{ minWidth: 'auto' }}><span className="lab">БЛ непокр</span><span className="val">{cntPill(a.sick, 'bad')}</span></div>
    <div className="dm" style={{ minWidth: 'auto' }}><span className="lab">ОТ непокр</span><span className="val">{cntPill(a.vac, 'warn')}</span></div>
    <div className="dm" style={{ minWidth: 'auto' }}><span className="lab">Вакансий</span><span className="val">{cntPill(a.vacRoutes, 'vac')} <span style={{ fontSize: 10, color: '#888' }}>· {a.vacDays} дн</span></span></div>
  </div>);
}

// ── Недельный ряд агрегатов для набора маршрутов ───────────────────────────
// Возвращает [{ week, order, plan, fact, exits, routes, overlaps, sick, vac, vacDays,
//               vacRoutes, pq, pf, sl }] по каждой неделе периода.
export function weeklySeries(routes, weekNums, rweeks) {
  return weekNums.map(w => {
    const a = aggregateWeeks(routes, [w], rweeks);
    return {
      week: w, ...a,
      pq: a.order ? Math.round(a.plan / a.order * 100) : null,
      pf: a.fact ? Math.round(a.plan / a.fact * 100) : null,
      sl: a.order ? Math.round(a.fact / a.order * 100) : null,
    };
  });
}

// Недельный ряд гиппера
export function weeklyHyperSeries(routes, weeks, weekNums, hdata) {
  return weekNums.map(w => {
    const dates = (weeks[w]?.days || []).map(d => d.date);
    const a = aggregateHyper(routes, dates, hdata);
    return { week: w, ...a };
  });
}

// ── График динамики (inline-SVG, без зависимостей) ─────────────────────────
// series: [{ key, name, color, dash? }], data: ряд из weeklySeries, unit: '%'|''
// refs: [{ y, label }] — целевые линии.
export function DynamicsChart({ data, series, unit = '', refs = [], height = 210 }) {
  const [hi, setHi] = useState(null);
  const wrapRef = useRef(null);
  const W = 720, H = height, padL = 36, padR = 54, padT = 14, padB = 26;
  const n = data.length;
  const xs = i => padL + (n <= 1 ? 0 : i * (W - padL - padR) / (n - 1));
  const allVals = series.flatMap(s => data.map(d => d[s.key])).filter(v => v != null);
  const refVals = refs.map(r => r.y);
  let vmax = Math.max(1, ...allVals, ...refVals);
  let vmin = Math.min(...allVals, ...refVals);
  if (unit === '%') {
    // сфокусированный диапазон для процентов, чтобы движение читалось
    const p = (vmax - vmin) * 0.25 || 5;
    vmin = Math.max(0, Math.floor((vmin - p) / 5) * 5);
    vmax = Math.ceil((vmax + p) / 5) * 5;
  } else {
    vmin = 0; vmax = vmax * 1.15 || 1;
  }
  const yScale = v => padT + (1 - (v - vmin) / (vmax - vmin || 1)) * (H - padT - padB);
  const ticks = 4;
  const gridVals = Array.from({ length: ticks + 1 }, (_, i) => vmin + (vmax - vmin) * i / ticks);

  function pathFor(s) {
    let d = '', pen = false;
    data.forEach((row, i) => {
      const v = row[s.key];
      if (v == null) { pen = false; return; }
      d += (pen ? ' L' : ' M') + xs(i).toFixed(1) + ' ' + yScale(v).toFixed(1);
      pen = true;
    });
    return d;
  }

  function onMove(e) {
    const r = wrapRef.current.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width * W;
    let best = 0, bd = Infinity;
    data.forEach((_, i) => { const dd = Math.abs(xs(i) - x); if (dd < bd) { bd = dd; best = i; } });
    setHi(best);
  }

  return (
    <div className="dyn-wrap">
      <div className="dyn-legend">
        {series.map(s => (
          <span key={s.key} className="dyn-lg">
            <span className="dyn-sw" style={{ background: s.color, borderStyle: s.dash ? 'dashed' : 'solid' }} />{s.name}
          </span>
        ))}
      </div>
      <div ref={wrapRef} style={{ position: 'relative' }}
           onMouseMove={onMove} onMouseLeave={() => setHi(null)}>
        <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ display: 'block', overflow: 'visible' }}>
          {gridVals.map((gv, i) => (
            <g key={i}>
              <line x1={padL} x2={W - padR} y1={yScale(gv)} y2={yScale(gv)} stroke="var(--border)" strokeWidth="1" />
              <text x={padL - 6} y={yScale(gv) + 3} textAnchor="end" fontSize="10" fill="var(--text-light)">{Math.round(gv)}{unit}</text>
            </g>
          ))}
          {refs.map((rf, i) => (
            <g key={'r' + i}>
              <line x1={padL} x2={W - padR} y1={yScale(rf.y)} y2={yScale(rf.y)} stroke="var(--text-light)" strokeWidth="1" strokeDasharray="4 4" />
              <text x={W - padR + 4} y={yScale(rf.y) + 3} fontSize="9" fill="var(--text-light)">{rf.label}</text>
            </g>
          ))}
          {data.map((row, i) => (
            <text key={'x' + i} x={xs(i)} y={H - 8} textAnchor="middle" fontSize="10"
                  fill={hi === i ? 'var(--text)' : 'var(--text-muted)'} fontWeight={hi === i ? 700 : 400}>W{row.week}</text>
          ))}
          {hi != null && <line x1={xs(hi)} x2={xs(hi)} y1={padT} y2={H - padB} stroke="var(--border)" strokeWidth="1.5" />}
          {series.map(s => (
            <path key={s.key} d={pathFor(s)} fill="none" stroke={s.color} strokeWidth="2"
                  strokeDasharray={s.dash ? '5 4' : 'none'} strokeLinejoin="round" strokeLinecap="round" />
          ))}
          {series.map(s => data.map((row, i) => row[s.key] == null ? null : (
            <circle key={s.key + i} cx={xs(i)} cy={yScale(row[s.key])} r={hi === i ? 4.5 : 3}
                    fill="var(--surface)" stroke={s.color} strokeWidth="2" />
          )))}
        </svg>
        {hi != null && (
          <div className="dyn-tip" style={{ left: `calc(${xs(hi) / W * 100}% )` }}>
            <div className="dyn-tip-h">W{data[hi].week}</div>
            {series.map(s => (
              <div key={s.key} className="dyn-tip-r">
                <span className="dyn-sw" style={{ background: s.color }} />{s.name}
                <b>{data[hi][s.key] == null ? '—' : data[hi][s.key] + unit}</b>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

// ── Триггеры (авто-алерты) ─────────────────────────────────────────────────
// items: [{ level:'bad'|'warn'|'info', title, detail }]
export function TriggersCard({ items }) {
  return (
    <div className="trigwrap">
      <div className="trig-h">⚡ Триггеры{items.length ? ` · ${items.length}` : ''}</div>
      {items.length === 0
        ? <div className="trig-empty">✓ Активных триггеров нет</div>
        : items.map((it, i) => (
          <div key={i} className={'trig ' + (it.level || 'bad')}>
            <span className="trig-ic">!</span>
            <div className="trig-txt"><b>{it.title}</b><span>{it.detail}</span></div>
            {it.go && <button className="trig-go" onClick={it.go}>Перейти</button>}
          </div>
        ))}
    </div>
  );
}

// ── Ряд табов-переключателей (BU / ТМ / СВ) ────────────────────────────────
// items: [{ id, label }], value: id, onPick(id)
export function ScopeTabs({ label, items, value, onPick }) {
  return (
    <div className="stabs">
      {label && <span className="stabs-l">{label}</span>}
      {items.map(it => (
        <button key={it.id} className={'stab' + (it.id === value ? ' on' : '')} onClick={() => onPick(it.id)}>{it.label}</button>
      ))}
    </div>
  );
}

// ── Нейтральная бизнес-полоса недель с крупной дисциплиной ──────────────────
export function WeekStrip({ data, view }) {
  return (
    <div className="wstrip">
      {data.map(d => (
        <div key={d.week} className="wcard">
          <div className="wtop"><span className="wk">W{d.week}</span>{d.sl != null && <span className={'wsl ' + (d.sl >= 95 ? 'ok' : d.sl >= 90 ? 'warn' : 'bad')}>SL {d.sl}%</span>}</div>
          {view === 'kpi' ? (
            <>
              <div className="wbig">{d.activeR}<span className="wbig-u">актив.</span></div>
              <div className="wsub">из {d.routes} маршрутов</div>
              <div className="wfact">
                <span>Визитов</span><b>{d.fact}</b><span className="wfact-vs">/ {d.order} заказ</span>
              </div>
              <div className="wrow2">
                <div className="wmini"><span>Прогноз/Заказ</span><b>{d.pq == null ? '—' : d.pq + '%'}</b></div>
                <div className="wmini"><span>Прогноз/Факт</span><b>{d.pf == null ? '—' : d.pf + '%'}</b></div>
              </div>
            </>
          ) : view === 'hyper' ? (
            <>
              <div className="wbig">{d.fact}<span className="wbig-u">факт</span></div>
              <div className="wsub">заказ {d.order} · {d.points} точек</div>
              <div className="wrow2">
                <div className="wmini"><span>План/Заказ</span><b>{d.pq == null ? '—' : d.pq + '%'}</b></div>
                <div className="wmini"><span>Ниже нормы</span><b>{d.below}<small style={{ fontSize: 9, color: 'var(--text-light)' }}> /{d.withOrder}</small></b></div>
              </div>
            </>
          ) : (
            <div className="wdisc">
              <div className="wd cov"><span>Перекрытия</span><b>{d.overlaps}</b></div>
              <div className="wd bad"><span>БЛ непокр</span><b>{d.sick}</b></div>
              <div className="wd warn"><span>ОТ непокр</span><b>{d.vac}</b></div>
              <div className="wd vac"><span>Вакансии</span><b>{d.vacRoutes}<small>· {d.vacDays} дн</small></b></div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

// Строка деталей гиппера (по СВ / точке)
export function HyperMetricRow({ name, a }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 2px', borderTop: '1px solid var(--border)', flexWrap: 'wrap' }}>
      <span style={{ flex: '1 1 130px', fontSize: 12, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{name}</span>
      <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>точек {a.points}</span>
      <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>факт {a.fact}/{a.order}</span>
      {slPill(a.fact, a.order)}
      <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>ниже нормы</span>{cntPill(a.below, 'bad')}
    </div>
  );
}

// Строка деталей по маршруту
export function RouteMetricRow({ name, m, view }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 2px', borderTop: '1px solid var(--border)', flexWrap: 'wrap' }}>
      <span style={{ flex: '1 1 130px', fontSize: 12, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{name}</span>
      {view === 'kpi'
        ? <><span style={{ fontSize: 10, color: 'var(--text-muted)' }}>вых {m.exits}</span>{pqPill(m.plan, m.order)}{pfPill(m.plan, m.fact)}{slPill(m.fact, m.order)}</>
        : <><span style={{ fontSize: 10, color: 'var(--text-muted)' }}>Пер</span>{cntPill(m.overlaps, 'cov')}<span style={{ fontSize: 10, color: 'var(--text-muted)' }}>БЛ</span>{cntPill(m.sick, 'bad')}<span style={{ fontSize: 10, color: 'var(--text-muted)' }}>ОТ</span>{cntPill(m.vac, 'warn')}<span style={{ fontSize: 10, color: 'var(--text-muted)' }}>ВК</span>{cntPill(m.vacDays, 'vac')}</>}
    </div>
  );
}
